import { MessageTemplateDAO } from '../DAO/MessageTemplateDAO';
import { toCamel } from '../Util/SnakeCamelUtil';
import { BaseService } from './BaseService';
import { MailTemplateDTOInterface } from '../DTO/MailTemplateDTOInterface';
import {MailTemplateCategoryDTOInterface} from '../DTO/MailTemplateCategoryDTOInterface';
import {MessageTemplateCategoryDAO} from '../DAO/MessageTemplateCategoryDAO';


/**
 * MessageTemplateService
 * テンプレートに関するサービス
 */
export class MessageTemplateService extends BaseService {


	/**
	 * getMailTemplateList
	 * メールテンプレート一覧を取得。
	 */
	public async getMailTemplateList(): Promise<MailTemplateDTOInterface[]> {

		const dao = new MessageTemplateDAO(this as BaseService);
		const lst = await dao.getMailTemplateList();

		if (!lst) {
			return null;
		}

		// mail_template_categoryのキーをmailTemplateCategoryに変換する。
		const newList: MailTemplateDTOInterface[] = [];
		for (const mailTemplate of lst) {
			newList.push({
				id: mailTemplate.id,
				name: mailTemplate.name,
				subject: mailTemplate.subject,
				content: mailTemplate.content,
				mailTemplateCategory: this.obj2Array(toCamel(mailTemplate.mail_template_category))
			});
		}

		return newList;
	}


	/**
	 * getMailTemplateList
	 * メールテンプレートを取得。
	 * @param templateId メールテンプレートID
	 * @return Promise<any>
	 */
	public async getMailTemplate(templateId: number): Promise<MailTemplateDTOInterface> {

		const dao = new MessageTemplateDAO(this as BaseService);
		const data = await dao.getMailTemplate(templateId);
		if (!data) {
			return null;
		}

		const mailTemplate: MailTemplateDTOInterface = {
			id: data.id,
			name: data.name,
			subject: data.subject,
			content: data.content,
			mailTemplateCategory: this.obj2Array(toCamel(data.mail_template_category))
		};

		return mailTemplate;

	}


	/**
	 * addMailTemplate
	 * メールテンプレートを登録。
	 * @param data メールテンプレートデータ
	 * @return Promise<any>
	 */
	public async addMailTemplate(data: MailTemplateDTOInterface): Promise<MailTemplateDTOInterface> {

		const dao = new MessageTemplateDAO(this as BaseService);
		const ret = await dao.addMailTemplate(
			data.name,
			data.subject,
			data.content,
			data.mailTemplateCategory
		);
		if (!ret) {
			return null;
		}


		return ret;

	}

	/**
	 * editMailTemplate
	 * @return Promise<any>
	 */
	public async editMailTemplate(data: MailTemplateDTOInterface): Promise<MailTemplateDTOInterface> {

		const dao = new MessageTemplateDAO(this as BaseService);
		const ret = await dao.editMailTemplate(
			data.id,
			data.name,
			data.subject,
			data.content,
			data.mailTemplateCategory
		);
		if (!ret) {
			return null;
		}


		return ret;

	}

	/**
	 * deleteMailTemplate
	 * メールテンプレートを削除。
	 * @param templateId メールテンプレートID
	 * @return Promise<any>
	 */
	public async deleteMailTemplate(templateId: number): Promise<any> {

		this.log('start delete mail template');

		const dao = new MessageTemplateDAO(this as BaseService);
		const ret = await dao.deleteMailTemplate(templateId);
		if (!ret) {
			return null;
		}


		return ret;

	}


	/**
	 * メールテンプレートのカテゴリ一覧取得
	 */
	public async getMailTemplateCategoryList(): Promise<MailTemplateCategoryDTOInterface[]> {

		const dao = new MessageTemplateCategoryDAO(this as BaseService);
		const lst = await dao.getList();

		if (!lst) {
			return null;
		}

		return this.obj2Array(toCamel(lst));
	}

	/**
	 * 詳細データ取得
	 * @param templateId
	 */
	public async getMailTemplateCategory(templateId: number): Promise<any> {

		const dao = new MessageTemplateCategoryDAO(this as BaseService);
		const data = await dao.getMailTemplateCategory(templateId);
		if (!data) {
			return null;
		}

		return toCamel(data);
	}


	/**
	 * addMailTemplateCategory
	 * メールテンプレートカテゴリを登録。
	 * @param data メールテンプレートカテゴリデータ
	 * @return Promise<any>
	 */
	public async addMailTemplateCategory(data: MailTemplateCategoryDTOInterface): Promise<any> {

		const dao = new MessageTemplateCategoryDAO(this as BaseService);
		const ret = await dao.create(
			data.name,
		);
		if (!ret) {
			return null;
		}


		return ret;

	}

	/**
	 * editMailTemplateCategory
	 * メールテンプレートカテゴリを編集。
	 * @param data メールテンプレートカテゴリデータ
	 * @return Promise<any>
	 */
	public async editMailTemplateCategory(data: MailTemplateCategoryDTOInterface): Promise<any> {

		const dao = new MessageTemplateCategoryDAO(this as BaseService);
		const ret = await dao.update(
			data.id,
			data.name,
		);
		if (!ret) {
			return null;
		}


		return ret;

	}

	/**
	 * deleteMailTemplateCategory
	 * メールテンプレートカテゴリを削除。
	 * @param templateId メールテンプレートカテゴリID
	 * @return Promise<any>
	 */
	public async deleteMailTemplateCategory(templateId: number): Promise<any> {

		this.log('start delete mail template');

		const dao = new MessageTemplateCategoryDAO(this as BaseService);
		const ret = await dao.delete(templateId);
		if (!ret) {
			return null;
		}


		return ret;

	}
}

// データ受け渡し用のクラス
export class MailTemplateData {
	id: number;
	name: string;
	subject: string;
	content: string;
}
